import React from 'react';
import { observer } from 'mobx-react';
import { TagStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class TagCreate extends React.Component {

  onCreate = name => {
    const data = {
      name,
      tag_category_id: this.props.tagCategoryId,
      group_id: this.props.groupId,
    };
    TagStore.create({data}, this.props.afterChange);
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Enter Tag Name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default TagCreate;
